import React from "react";
import img1 from "../slides/party_slide2.jpg";
import img2 from "../slides/party_slide3.jpg";
import LoadScript from "../helpers/LoadScript";
const HeroKenburn = () => {
  LoadScript("./js/master.js");
  return (
    <div
      id="rev_slider_1078_1_wrapper"
      className="rev_slider_wrapper fullwidthbanner-container slide-overlay"
      data-alias="classNameic4export"
      data-source="gallery"
      style={{
        zIndex: 0,
        width: "100%",
        position: "relative",
        padding: "0",
      }}
    >
      <div
        id="rev_slider_1078_1"
        className="rev_slider fullwidthabanner anno-rs"
        style={{ display: "none" }}
        data-version="5.4.1"
      >
        <ul>
          <li
            data-index="rs-1"
            data-transition="boxslide"
            data-slotamount="default"
            data-hideafterloop="0"
            data-hideslideonmobile="off"
            data-easein="default"
            data-easeout="default"
            data-masterspeed="default"
            data-thumb=""
            data-delay="10010"
            data-rotate="0"
            data-saveperformance="off"
            data-title="Let’s Have a Party!"
            data-param1=""
            data-param2=""
            data-param3=""
            data-param4=""
            data-param5=""
            data-param6=""
            data-param7=""
            data-param8=""
            data-param9=""
            data-param10=""
            data-description=""
          >
            <img
              src={img1}
              alt=""
              title="slider-mainbg-003"
              width="1920"
              height="915"
              data-bgposition="center center"
              data-bgfit="cover"
              data-bgrepeat="no-repeat"
              className="rev-slidebg"
              data-no-retina
            />

            <div
              className="tp-caption tp-resizeme head-font"
              id="slide-1-layer-1"
              data-x="['center','center','center','center']"
              data-hoffset="['0','0','0','0']"
              data-y="['middle','middle','middle','middle']"
              data-voffset="['-126','-177','-156','-199']"
              data-fontsize="['36','36','36','28']"
              data-lineheight="['45','45','35','35']"
              data-fontweight="['400','400','400','400']"
              data-color="['#fff','#fff','#fff','#fff']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-responsive_offset="on"
              data-frames='[{"delay":210,"speed":1500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textalign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            >
              Transform your guestbook experience
            </div>

            {/* <!-- <div className="tp-caption tp-resizeme highlight-skin-button" id="slide-1-layer-2" data-x="['center','center','center','center']" data-hoffset="['0','0','0','0']" data-y="['middle','middle','middle','middle']" data-voffset="['-70','-121','-105','-52']"  

                                data-fontsize="['20','18','20','14']"
                                data-lineheight="['22','20','22','20']"
                                data-fontweight="['300','300','300','300']"
                                data-width="none"
                                data-height="none"
                                data-whitespace="nowrap"
                                data-type="text"
                                data-responsive_offset="on"
                                data-frames='[{"delay":930,"speed":900,"frame":"0","from":"z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power3.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
                                data-textalign="['inherit','inherit','inherit','inherit']"
                                data-paddingtop="[6,6,6,5]"
                                data-paddingright="[18,18,18,18]"
                                data-paddingbottom="[6,6,6,5]"
                                data-paddingleft="[18,18,18,18]"
                                >December 03rd 2018</div> --> */}

            <div
              className="tp-caption tp-resizeme tp-shapewrapper"
              id="slide-1-layer-3"
              data-x="['center','center','center','center']"
              data-hoffset="['269','269','201','134']"
              data-y="['middle','middle','middle','middle']"
              data-voffset="['12','6','-7','-69']"
              data-width="['311','311','236','154']"
              data-height="['23','23','24','17']"
              data-whitespace="nowrap"
              data-type="shape"
              data-responsive_offset="on"
              data-frames='[{"delay":1980,"speed":1000,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textalign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            ></div>

            <div
              className="tp-caption tp-resizeme heading-slide"
              id="slide-1-layer-4"
              data-x="['center','center','center','center']"
              data-hoffset="['0','0','0','0']"
              data-y="['middle','middle','middle','middle']"
              data-voffset="['-18','-21','-27','-100']"
              data-fontsize="['85','85','62','42']"
              data-lineheight="['110','110','110','110']"
              data-fontweight="['600','600','600','600']"
              data-color="['#fff','#fff','#fff','#fff']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-responsive_offset="on"
              data-frames='[{"delay":880,"split":"chars","splitdelay":0.05,"speed":1500,"split_direction":"forward","frame":"0","from":"y:[100%];z:0;rZ:-35deg;sX:1;sY:1;skX:0;skY:0;","mask":"x:0px;y:0px;s:inherit;e:inherit;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textalign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            >
              LET'S HAVE A PARTY!
            </div>

            <div
              className="tp-caption tp-resizeme"
              id="slide-1-layer-5"
              data-x="['center','center','center','center']"
              data-hoffset="['0','0','0','0']"
              data-y="['middle','middle','middle','middle']"
              data-voffset="['109','82','53','53']"
              data-fontsize="['16','16','16','14']"
              data-lineheight="['26','26','26','24']"
              data-fontweight="['600','600','600','600']"
              data-color="['#e0e0e0','#e0e0e0','#e0e0e0','#e0e0e0']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-visibility="['on','on','on','off']"
              data-type="text"
              data-responsive_offset="on"
              data-frames='[{"delay":2010,"speed":1500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textalign="['center','center','center','center']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            >
              Capture the best moments from your guests in your digital event
              gallery.
              <br />
              easy, and it takes skills (and time) to make it all look
              easy-going{" "}
            </div>

            <a
              className="tp-caption tp-resizeme highlight-skin-button"
              href="/howitworks"
              target="_self"
              id="slide-1-layer-6"
              data-x="['center','center','center','center']"
              data-hoffset="['-97','-97','-97','-97']"
              data-y="['middle','middle','middle','middle']"
              data-voffset="['203','182','127','45']"
              data-fontsize="['14','14','14','20']"
              data-lineheight="['14','14','14','14']"
              data-fontweight="['600','600','600','600']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-actions=""
              data-responsive_offset="on"
              data-frames='[{"delay":2260,"speed":1500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textalign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[15,15,15,10]"
              data-paddingright="[30,30,30,25]"
              data-marginright="[30,30,30,25]"
              data-paddingbottom="[15,15,15,10]"
              data-paddingleft="[30,30,30,25]"
            >
              How it works?{" "}
            </a>

            <a
              className="tp-caption tp-resizeme classic-border-button"
              href="/pricing"
              target="_self"
              id="slide-1-layer-7"
              data-x="['center','center','center','center']"
              data-hoffset="['98','98','98','98']"
              data-y="['middle','middle','middle','middle']"
              data-voffset="['203','182','128','45']"
              data-fontsize="['14','14','14','20']"
              data-lineheight="['14','14','14','14']"
              data-fontweight="['600','600','600','600']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-actions=""
              data-responsive_offset="on"
              data-frames='[{"delay":2260,"speed":1500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textalign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[15,15,15,10]"
              data-paddingright="[30,30,30,25]"
              data-paddingbottom="[15,15,15,10]"
              data-paddingleft="[30,30,30,25]"
            >
              Pricing Plans{" "}
              <span>
                <i className="ti ti-angle-right"></i>
              </span>
            </a>
          </li>
          <li
            data-index="rs-2"
            data-transition="slotslide-vertical,fade"
            data-slotamount="default,default"
            data-hideafterloop="0"
            data-hideslideonmobile="off"
            data-easein="default,default"
            data-easeout="default,default"
            data-masterspeed="default,300"
            data-thumb=""
            data-delay="10010"
            data-rotate="0,0"
            data-saveperformance="off"
            data-title="We Plan the Best Events"
            data-param1=""
            data-param2=""
            data-param3=""
            data-param4=""
            data-param5=""
            data-param6=""
            data-param7=""
            data-param8=""
            data-param9=""
            data-param10=""
            data-description=""
          >
            <img
              src={img2}
              alt=""
              title="slider-mainbg-003"
              width="1920"
              height="915"
              data-bgposition="center center"
              data-bgfit="cover"
              data-bgrepeat="no-repeat"
              className="rev-slidebg"
              data-no-retina
            />

            <div
              class="tp-caption tp-shapewrapper ttm-bgcolor-skincolor tp-resizeme"
              id="slide-1-layer-1"
              data-x="['left','left','left','left']"
              data-hoffset="['50','50','40','-50']"
              data-y="['top','top','top','top']"
              data-voffset="['200','240','70','100']"
              data-fontsize="['15','15','8','8']"
              data-lineheight="['26','26','20','20']"
              data-width="10"
              data-height="200"
              data-whitespace="nowrap"
              data-visibility="['on','on','on','off']"
              data-type="shape"
              data-responsive_offset="on"
              data-frames='[{"delay":220,"speed":470,"frame":"0","from":"x:50px;opacity:0;","to":"o:1;","ease":"Power3.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textAlign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            ></div>

            <div
              class="tp-caption tp-resizeme"
              id="slide-1-layer-2"
              data-x="['left','left','left','left']"
              data-hoffset="['90','90','71','20']"
              data-y="['top','top','top','middle']"
              data-voffset="['195','234','64','-100']"
              data-fontsize="['24','24','24','20']"
              data-lineheight="['70','70','70','60']"
              data-fontweight="[600,600,600,600]"
              data-color="['#ffffff','#ffffff','#ffffff','#ffffff']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-responsive_offset="on"
              data-frames='[{"delay":380,"speed":1500,"frame":"0","from":"x:[175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;","mask":"x:[-100%];y:0;s:inherit;e:inherit;","to":"o:1;","ease":"Power3.easeOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textAlign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            >
              GuestPOV is a{" "}
              <strong class="ttm-textcolor-skincolor">local</strong>,
              <strong class="ttm-textcolor-skincolor"> streamlined</strong>{" "}
              solution
            </div>

            <div
              class="tp-caption tp-resizeme"
              id="slide-1-layer-3"
              data-x="['left','left','left','left']"
              data-hoffset="['89','89','69','20']"
              data-y="['top','top','top','middle']"
              data-voffset="['260','302','130','-38']"
              data-fontsize="['65','65','65','35']"
              data-lineheight="['70','70','70','60']"
              data-fontweight="[600,600,600,600]"
              data-color="['#ffffff','#ffffff','#ffffff','#ffffff']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-responsive_offset="on"
              data-frames='[{"delay":890,"speed":1500,"frame":"0","from":"x:[-175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;","mask":"x:[100%];y:0;s:inherit;e:inherit;","to":"o:1;","ease":"Power3.easeOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textAlign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            >
              designed to make{" "}
            </div>

            <div
              class="tp-caption tp-resizeme"
              id="slide-1-layer-4"
              data-x="['left','left','left','left']"
              data-hoffset="['89','89','70','20']"
              data-y="['top','top','top','middle']"
              data-voffset="['330','370','203','23']"
              data-fontsize="['65','65','65','35']"
              data-lineheight="['70','70','70','60']"
              data-fontweight="[600,600,600,600]"
              data-color="['#ffffff','#ffffff','#ffffff','#ffffff']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-responsive_offset="on"
              data-frames='[{"delay":1400,"speed":1500,"frame":"0","from":"x:[175%];y:0px;z:0;rX:0;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:1;","mask":"x:[-100%];y:0;s:inherit;e:inherit;","to":"o:1;","ease":"Power3.easeOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textAlign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            >
              <strong class="ttm-textcolor-skincolor">memory-sharing </strong>
              effortless.
            </div>

            <div
              class="tp-caption tp-resizeme"
              id="slide-1-layer-5"
              data-x="['left','left','left','left']"
              data-hoffset="['50','50','50','50']"
              data-y="['top','top','top','top']"
              data-voffset="['440','460','500','440']"
              data-fontsize="['20','20','20','20']"
              data-lineheight="['28','28','28','28']"
              data-color="['#ffffff','#ffffff','#ffffff','#ffffff']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-visibility="['on','on','off','off']"
              data-type="text"
              data-responsive_offset="on"
              data-frames='[{"delay":1460,"speed":1500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textAlign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[0,0,0,0]"
              data-paddingright="[0,0,0,0]"
              data-paddingbottom="[0,0,0,0]"
              data-paddingleft="[0,0,0,0]"
            >
              Because the best part of any event isn’t just what you see—it’s
              <br></br>
              how your guests see it, too.
            </div>

            <a
              class="tp-caption tp-resizeme highlight-skin-button"
              href="/pricing"
              target="_self"
              id="slide-1-layer-6"
              data-x="['left','left','left','center']"
              data-hoffset="['50','50','40','0']"
              data-y="['middle','middle','middle','middle']"
              data-voffset="['260','220','103','95']"
              data-width="none"
              data-height="none"
              data-whitespace="nowrap"
              data-type="text"
              data-actions=""
              data-responsive_offset="on"
              data-frames='[{"delay":1750,"speed":1500,"frame":"0","from":"y:[100%];z:0;rX:0deg;rY:0;rZ:0;sX:1;sY:1;skX:0;skY:0;opacity:0;","to":"o:1;","ease":"Power4.easeInOut"},{"delay":"wait","speed":300,"frame":"999","to":"opacity:0;","ease":"Power3.easeInOut"}]'
              data-textAlign="['inherit','inherit','inherit','inherit']"
              data-paddingtop="[15,15,15,15]"
              data-paddingright="[30,30,30,30]"
              data-paddingbottom="[15,15,15,15]"
              data-paddingleft="[30,30,30,30]"
            >
              Pricing Plans{" "}
              <span>
                <i class="ti ti-angle-right"></i>
              </span>
            </a>
          </li>
        </ul>
        <div
          className="tp-bannertimer"
          style={{
            height: "3px",
            backgroundColor: "rgba(255, 255, 255, 0.25)",
          }}
        ></div>{" "}
      </div>
    </div>
  );
};

export default HeroKenburn;
